import { render, staticRenderFns } from "./CTable.vue?vue&type=template&id=5836380e&scoped=true"
import script from "./CTable.vue?vue&type=script&lang=js"
export * from "./CTable.vue?vue&type=script&lang=js"
import style0 from "./CTable.vue?vue&type=style&index=0&id=5836380e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5836380e",
  null
  
)

export default component.exports